<template>
  <div
    :id="`id_${id}`"
    :style="[indent]"
    data-cy="tree"
    class="TreeServiceBlocAnalysis"
  >
    <div>
      <v-toolbar
        v-if="isActive"
        dense
        class="site-list mb-1 tree--item"
        :class="bgColor"
      >
        <v-toolbar-title>
          <v-row justify="center">
            <v-col
              md="auto"
              cols="1"
              class="p-0 d-flex justify-center align-center"
            >
              <v-btn
                icon
                @click="toggleChildren"
              >
                <v-icon>
                  {{ iconArrow }}
                </v-icon>
              </v-btn>
            </v-col>
            <v-col
              md="auto"
              cols="1"
              class="p-0 d-flex justify-center align-center"
            >
              <div
                class="d-flex justify-center align-center"
                style="border: 1px solid #26384B; border-radius: 4px; width: 26px; height: 26px"
              >
                <v-icon
                  small
                  color="#26384B"
                >
                  {{ iconName }}
                </v-icon>
              </div>
            </v-col>
            <v-col
              md="auto"
              cols="9"
            >
              {{ nodeTitle }} {{ nodeState }}
            </v-col>
          </v-row>
        </v-toolbar-title>

        <v-spacer />

        <v-toolbar-items>
          <div class="buttons">
            <v-menu offsetY>
              <template v-slot:activator="{ on, attrs }">
                <div class="action-buttons">
                  <v-btn
                    color="primary"
                    icon
                    small
                    v-bind="attrs"
                    :data-cy="dataCyNodeDotsIcon"
                    :disabled="isCompletedOrLocked"
                    v-on="on"
                  >
                    <v-icon
                      color="#26384B"
                    >
                      mdi-dots-vertical
                    </v-icon>
                  </v-btn>
                </div>
              </template>

              <v-list v-if="nodeType === 'Container' || nodeType === 'Network' || nodeType === 'Site' ">
                <template>
                  <v-list-item
                    v-for="(action,idx) in itemActionsContainerAndNetwork"
                    :key="idx"
                    @click="showTechnicalFile(nodeItem)"
                  >
                    <v-list-item-content :key="idx">
                      <v-list-item-title>
                        <v-icon
                          :style="`${action.iconAndTextColor ? `color:${action.iconAndTextColor}` : ''}`"
                          v-text="action.icon"
                        />
                        {{ $t(`clients.${action.name}`) }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list>
              <v-list v-if="nodeType === 'Component'">
                <!-- With 3 choices  -->
                <template>
                  <div
                    v-for="(action,idx) in itemActionsComponent"
                    :key="idx"
                  >
                    <v-list-item
                      v-if="action.name === 'technicalFiles'"
                      @click="showTechnicalFile(nodeItem)"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-icon />
                          {{ $t(`clients.${action.name}`) }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      v-if="action.name === 'addAnalysis'"
                      @click="buttonConfirmAnalysis(nodeItem)"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-icon />
                          {{ $t(`clients.${action.name}`) }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      v-if="action.name === 'labRequest'"
                      data-cy="labRequest"
                      @click="buttonLabRequest(nodeItem)"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-icon />
                          {{ $t(`clients.${action.name}`) }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                </template>
              </v-list>
            </v-menu>
          </div>
        </v-toolbar-items>
      </v-toolbar>
    </div>

    <div v-if="isActive && mutableNodeItem.showChildren">
      <AnalysisTable
        v-if="isGridViewActive"
        :networkId="id"
        :isCompletedOrLocked="isCompletedOrLocked"
        :analysisUpdates="analysisUpdates"
        :mapComponentIdToServices="mapComponentIdToServices"
        :tables="tables"
        @onAddAnalysisToComponent="onAddAnalysisToComponent"
        @getTables="getTables"
      />
      <div
        v-for="node in mutableNodes"
        :key="node.ref"
      >
        <TreeService
          v-show="!isEmpty(node) && (!isNodeType(node.nodeType === 'Network' ? 'Component' : 'Network')
            || activeView !== 'gridView') && hasPermission('nodes.children.view')"
          :id="node.ref"
          :nodeType="node.nodeType"
          :name="node.name"
          :nodeItem="{
            ...node,
            parentNode,
            siteId,
          }"
          :nodes="node.children"
          :parentNode="{
            id,
            name,
            nodeType
          }"
          :site="site"
          :showAll="showAll"
          :mapComponentIdToServices="mapComponentIdToServices"
          :mapAnalyisTypesByRef="mapAnalyisTypesByRef"
          :depth="depth + 1"
          :activeView="activeView"
          :tables="tables"
          @input="$emit('input', $event)"
          @refresh-data="$emit('refresh-data', $event)"
          @nodeItemChanged="$emit('nodeItemChanged', $event)"
          @getTables="getTables"
        />
      </div>

      <v-container v-if="isNodeEmpty">
        <v-row
          align="center"
          justify="center"
        >
          <h5>{{ emptyMessage }}</h5>
        </v-row>
      </v-container>

      <div
        v-show="isNodeType('Component') && !isNodeEmpty && activeView !== 'gridView'"
      >
        <Measures
          :componentId="id"
          :analyses="analyses"
          :site="site"
          :activeView="activeView"
          :isCompletedOrLocked="isCompletedOrLocked"
        />
        <AnalysisRequests
          :componentId="id"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import treeMixin from '@/mixins/TreeMixin';
import SampleForm from '@/components/forms/sample/SampleForm';
import completionStatus from '@/constants/workOrderStatusChoices';
import AddAnalysisForm from '@/components/component/AddAnalysisForm.vue';
import { cloneDeep } from 'lodash';
import AnalysisRequests from './AnalysisRequests.vue';
import Measures from './Measures.vue';
import AnalysisTable from './AnalysisTable.vue';

export default {
    name: 'TreeService',
    components: {
        AnalysisRequests,
        Measures,
        AnalysisTable,
    },
    mixins: [
        treeMixin,
    ],
    props: {
        mapComponentIdToServices: {
            type: Object,
            default: () => ({}),
        },
        mapAnalyisTypesByRef: {
            type: Object,
            default: () => ({}),
        },
        activeView: {
            type: String,
            default: 'gridView',
        },
        mapfirstLoadSelectedAnalysis: {
            type: Array,
            default: () => ([]),
        },
        tables: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            itemActionsContainerAndNetwork: [{ name: 'technicalFiles' }],
            itemActionsComponent: [{ name: 'technicalFiles' }, { name: 'addAnalysis' }, { name: 'labRequest' }],
            mutableNodes: [],
            pressedCompId: '',
            analysisUpdates: 0,
        };
    },

    computed: {
        ...mapGetters([
            'currentMember',
            'workOrder',
            'hasPermission',
        ]),
        isGridViewActive() {
            return this.isNodeType('Network')
                && !this.isNodeEmpty
                && this.activeView === 'gridView';
        },
        analyses() {
            if (this.pressedCompId) {
                return this.mapComponentIdToServices[this.pressedCompId] ? this.mapComponentIdToServices[this.pressedCompId].analyses : [];
            }
            return this.mapComponentIdToServices[this.id]
                ? this.mapComponentIdToServices[this.id].analyses
                : [];
        },
        firstLoadSelectedAnalysis() {
            return this.mapfirstLoadSelectedAnalysis;
        },
        isNodeType() {
            return nodeType => this.nodeType === nodeType;
        },
        isEmpty() {
            return node => (node.nodeType !== 'Component'
                && (!node.children || node.children.length === 0));
        },
        isCompletedOrLocked() {
            return this.workOrder.completionStatus === completionStatus.COMPLETED || !!this.workOrder?.lockData?.isLocked;
        },
        iconName() {
            let name = '';
            switch (this.nodeType) {
                case 'Site':
                    name = 'business';
                    break;
                case 'Component':
                    name = 'gas_meter';
                    break;
                case 'Network':
                    name = 'hub';
                    break;
                case 'Container':
                    name = 'developer_board';
                    break;
                default:
            }
            return name;
        },
        getSelectedAnalysis() {
            return this.analyses.map(item => item.analysisType.ref);
        },
        dataCyNodeDotsIcon() {
            return `${this.nodeTitle}3dotsBtn`;
        },
    },
    watch: {
        showAll(value) {
            this.mutableNodeItem.showChildren = value;
        },
        async $route(to) {
            if ((to.name === 'measuresAndSamplesActivity')) {
                await this.reloadWorkOrder(this.workOrder.id);
            }
        },
        nodes: {
            handler(val) {
                this.mutableNodes = [...val];
            },
            deep: true,
            immediate: true,
        },
    },
    created() {
        this.mutableNodeItem.showChildren = !this.isNodeType('Network') && !this.isNodeType('Component');
    },
    methods: {
        ...mapActions({
            reloadWorkOrder: 'getWorkOrderInfo',
        }),
        onClickAdd(e) {
            if (e === 'addAnalysisRequest') {
                this.showAddAnalysisRequestModal();
            } else if (e === 'addAnalysis') {
                this.sendAction('addAnalysis', this.nodeItem);
            }
        },
        showAddAnalysisRequestModal() {
            this.$root.$emit('showModal', {
                showNextPrevious: true,
                title: this.$t('analysisRequests.add'),
                component: Vue.component('SampleForm', SampleForm),
                payload: {
                    isWorkOrder: true,
                    sample: {
                        client: this.workOrder.site.client.ref,
                        site: this.workOrder.site.ref,
                        component: this.nodeItem.ref,
                    },
                },
                onConfirm: requestPayload => this.addAnalysisRequest(this.nodeItem.ref, requestPayload),
            });
        },
        prepareAnalysisRequest(requestPayload) {
            const payload = {};

            Object.keys(requestPayload).forEach(key => {
                if (requestPayload[key] && requestPayload[key].id) {
                    payload[key] = requestPayload[key].id;
                } else if (requestPayload[key]) {
                    payload[key] = requestPayload[key];
                }
            });

            payload.requestedBy = this.currentMember.id;
            payload.workOrder = this.workOrder.id;

            return payload;
        },
        async addAnalysisRequest(requestPayload) {
            /* Delete spaces before and after the PO Name */
            const copyPayload = cloneDeep(requestPayload);
            if (copyPayload.poNumber) copyPayload.poNumber = copyPayload.poNumber.trim();


            const payload = this.prepareAnalysisRequest(copyPayload);
            const { data } = await this.$rq.addAnalysisRequest(payload);
            this.$toasted.global.toast_success({
                message: this.$t('analysisRequests.added', { name: data.requestNumber }),
            });
            await this.reloadWorkOrder(this.workOrder.id);
        },
        buttonConfirmAnalysis(node) {
            this.$root.$emit('showModal', {
                title: this.$t('sites.nodes.addAnalysis'),
                component: Vue.component('AddAnalysisForm', AddAnalysisForm),
                payload: { node, selectedAnalysis: this.getSelectedAnalysis, firstLoadSelectedAnalysis: this.firstLoadSelectedAnalysis },
                onConfirm: requestPayload => {
                    this.updateAnalysis(requestPayload);
                },
            });
        },

        async addAnalysis(requestPayload) {
            const bodyParams = {
                component: requestPayload.componentId,
                norm: {},
            };
            const { data } = await this.$rq.getComponentConfigurations(requestPayload.componentId);
            data.configurations.every(config => {
                const configuration = requestPayload.analyses.find(({ id }) => id === config.analysisType.id);

                if (configuration) {
                    bodyParams.norm = config.norm;
                    return false;
                }
                return true;
            });

            const newElements = requestPayload.analyses.filter(analyse => !this.getSelectedAnalysis.includes(analyse.ref));
            if (newElements.length) {
                const addBodyParams = {
                    ...bodyParams,
                    analyses: newElements.map(el => el.ref),
                };
                await this.$rq.addWorkOrderManyAnalysisOnComponent(
                    this.workOrder.id,
                    this.workOrder.activities.measuresAndSamplesCollect.id,
                    addBodyParams,
                );

                await this.reloadWorkOrder(this.workOrder.id);
                this.$emit('refresh-data');
                this.$toasted.global.toast_success({
                    message: this.$t('msg.analysisAdded', { count: newElements.length }),
                });
            }
        },

        hasAnalysesChanged(newAnalyses, firstLoadSelectedAnalysis) {
            const currentAnalysisIds = new Set(firstLoadSelectedAnalysis);
            const newAnalysisIds = new Set(newAnalyses);
            const newElements = [...newAnalysisIds].filter(id => !currentAnalysisIds.has(id));
            const removedElements = [...currentAnalysisIds].filter(id => !newAnalysisIds.has(id));
            const hasAdditions = newElements.length > 0;
            const hasRemovals = removedElements.length > 0;

            return {
                hasAdditions,
                additions: newElements,
                hasRemovals,
                removals: removedElements,
            };
        },
        async updateAnalysis(requestPayload) {
            let addSuccess = false;
            let removeSuccess = false;

            try {
                const bodyParams = {
                    component: requestPayload.componentId,
                    norm: {},
                };
                const { data } = await this.$rq.getComponentConfigurations(requestPayload.componentId);
                data.configurations.every(config => {
                    const configuration = requestPayload.analyses.find(({ id }) => id === config.analysisType.id);
                    if (configuration) {
                        bodyParams.norm = config.norm;
                        return false;
                    }
                    return true;
                });

                const analysisChange = this.hasAnalysesChanged(requestPayload.analyses, requestPayload.firstLoadSelectedAnalysis);
                if (analysisChange.hasAdditions) {
                    const addBodyParams = {
                        ...bodyParams,
                        analyses: analysisChange.additions,
                    };
                    await this.$rq.addWorkOrderManyAnalysisOnComponent(
                        this.workOrder.id,
                        this.workOrder.activities.measuresAndSamplesCollect.id,
                        addBodyParams,
                    );
                    addSuccess = true;
                }

                if (analysisChange.hasRemovals) {
                    await this.$rq.removeWorkOrderManyAnalysisOnComponent(
                        this.workOrder.id,
                        this.workOrder.activities.measuresAndSamplesCollect.id,
                        { ...bodyParams, analyses: analysisChange.removals },
                    );
                    removeSuccess = true;
                }

                await this.reloadWorkOrder(this.workOrder.id);
                this.$emit('refresh-data');

                // Determine the message to show based on the success of add/remove operations
                let messageKey;
                let noChanges = false;
                let count = Math.abs(analysisChange.additions.length - analysisChange.removals.length);
                if (addSuccess && removeSuccess) {
                    messageKey = 'msg.analysisUpdated';
                    count = analysisChange.additions.length + analysisChange.removals.length;
                } else if (addSuccess) {
                    messageKey = 'msg.analysisAddedMany';
                } else if (removeSuccess) {
                    messageKey = 'msg.analysisRemovedMany';
                } else {
                    noChanges = true;
                }
                if (!noChanges) {
                    this.showSuccessToast(
                        this.$t(messageKey, { count }),
                    );
                }
                if (this.pressedCompId) {
                    // need to refresh the analysises list of GridView
                    this.analysisUpdates += 1;
                }
            } catch (error) {
                const errorMessage = this.$t('errors.workOrderAnalysis.updateFailed');
                this.showFailureToast(errorMessage);
            } finally {
                this.pressedCompId = '';
            }
        },

        showSuccessToast(message) {
            this.$toasted.global.toast_success({ message });
        },
        showFailureToast(message) {
            this.$toasted.global.toast_error({ message });
        },

        buttonLabRequest(nodeItem) {
            this.$root.$emit('showModal', {
                showNextPrevious: true,
                title: this.$t('analysisRequests.add'),
                component: Vue.component('SampleForm', SampleForm),
                payload: {
                    isWorkOrder: true,
                    isEdition: false,
                    sample: {
                        ...this.workOrder,
                        client: this.workOrder.site.client.ref,
                        site: this.workOrder.site.ref,
                        component: nodeItem.ref,
                    },
                },
                onConfirm: requestPayload => this.addAnalysisRequest(requestPayload),
            });
        },
        onAddAnalysisToComponent({ componentId }) {
            this.pressedCompId = componentId;
            const node = this.nodeItem?.children?.find(child => child.ref === componentId);
            this.buttonConfirmAnalysis(node);
        },
        getTables() {
            this.$emit('getTables');
        },
    },
};
</script>

<style lang="scss" scoped>
.buttons {
  display: flex;
  flex-direction: row;
  align-items: center
}
::v-deep .scrollbar-width {
  max-width: 100%;
  overflow-x: auto;
  margin-left: 45px;
}
::v-deep .v-toolbar__content {
  padding-left: 6px;
}
.tree--item {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
@media (max-width: 600px) {
  ::v-deep .scrollbar-width {
    margin-left: 0px;
  }
}
</style>

<style lang="scss">
@media screen and(max-width: 960px) {
  .TreeServiceBlocAnalysis {
    .analyse-table {
      overflow-x: auto;
      width: max-content;
      .analyse-type {
        position: relative;
      }
    }
  }
}
</style>
